/* global femcare, Swiper */

femcare.gallery.image = {

    init: function () {
        var $galleries = $('.image-gallery');

        if ($galleries.length) {
            $galleries.each(function (index, gallery) {
                var $gallery = $(gallery).find('.image-gallery__content');

                var swiper = new Swiper($gallery[0], {
                    breakpoints: {
                        320: {
                            spaceBetween: 15,
                            slidesPerView: 1.25
                        },
                        992: {
                            slidesPerView: 1.17,
                            spaceBetween: 30
                        }
                    },
                    centeredSlides: true,
                    navigation: {
                        nextEl: $gallery.find('.image-gallery__arrow--next')[0],
                        prevEl: $gallery.find('.image-gallery__arrow--previous')[0],
                    }
                });

                swiper.on('transitionEnd', this.onTranslated.bind(this, swiper, $gallery));

                $gallery.find('.image-gallery__page').on('click', function () {
                    var slideIndex = $(this).parent().index();
                    swiper.slideTo(slideIndex, 600);
                });

            }.bind(this));
        }
    },

    onTranslated: function (swiper, $gallery) {
        var $pagination = $gallery
            .closest('.image-gallery')
            .find('.image-gallery__pagination');

        if ($pagination.length) {
            var pageSelector = '.image-gallery__page';
            var activePageSelector = '.image-gallery__page--active'; 
            var activePageClass = 'image-gallery__page--active';
            
            $pagination.find(activePageSelector).removeClass(activePageClass);
            $pagination.find(pageSelector).eq(swiper.activeIndex).addClass(activePageClass);

            var $activeIndicator = $pagination.find('.image-gallery__sr-active-indicator');
            $pagination.find(pageSelector).eq(swiper.activeIndex).append($activeIndicator);
        }
    }
};